import React, { useState } from "react";
import {Box, Tooltip} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import HistoryList from "../../../../history-list";
import { NewDate } from "../../../../history-list/history-list";
import "./child-events.scss";
import { Scrollbars } from "react-custom-scrollbars";
import { Link, Redirect } from "react-router-dom";
import CreateInvoice from "./create-invoice";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "../../../../modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import MaskedInput from "react-text-mask";
import Input from "@material-ui/core/Input";
import LoopIcon from "@material-ui/icons/Loop";

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /[0-9]/]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(0.5),
  },
  textFields: {
    height: "20px",
    width: "20px",
  },
}));

const ChildEvents = (props) => {
  const classes = useStyles();

  const {
    openCreateInvoiceDialog,
    invoiceDialog,
    groupsPlan,
    children_id,
    createInvoice,
    invoiceDiscount,
    addEventChild,
    handleChangedHistory,
    historyChild,
    onCloseChangedHistory,
    handleChanged,
    closeChildAppend,
    child,
    updateClientResidual,
    showResidual,
    residual,
  } = props;
  const [openInvoice, setOpenInvoice] = useState({ id: "", open: false });
  const [openDialog, setOpenDialog] = useState(false);

  const addEvent = () => {
    setOpenDialog(false);
    addEventChild();
  };
  const onClose = () => {
    setOpenDialog(false);
    onCloseChangedHistory();
  };

  if (openInvoice.open === false) {
    return (
      <Box className={classes.content}>
        <Box className="contentBlock">
          <Box className="BlockHeader">
            <h3>События</h3>
            <IconButton
              className="btnChildEvent"
              onClick={() => setOpenDialog(true)}
            >
              <AddCircleIcon />
            </IconButton>
          </Box>
          {props.history.length ? (
            <Box className="childHistoryBlock">
              <Scrollbars>
                <HistoryList history={props.history} />
              </Scrollbars>
            </Box>
          ) : null}
        </Box>
        <Box className="contentBlock">
          <Box className="BlockHeader">
            <div className="BlockHeaderTitle">
              <h3>Занятия</h3>
              <div className="balance">
                <span>Баланс:</span>
                <Input
                  value={residual}
                  onChange={(e) => {
                    handleChanged(e.target.value);
                  }}
                  name="textmask"
                  id="formatted-text-mask-input"
                  inputComponent={TextMaskCustom}
                />
                {showResidual ? (
                  <CheckCircleIcon
                    id="doneChild"
                    onClick={updateClientResidual}
                  />
                ) : null}
              </div>
            </div>
            {props.status_id === 4 && (
              <Link
                to={{
                  pathname: "/admin/calendar",
                  state: { id: child.id, client_id: child.client_id },
                }}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  className="btnChildEvent"
                  onClick={closeChildAppend}
                >
                  <AddCircleIcon />
                </IconButton>
              </Link>
            )}
            {props.status_id === 1 && (
              <IconButton
                disabled={props.status_id === (2 || 3)}
                onClick={() => openCreateInvoiceDialog(true)}
                className="btnChildEvent"
              >
                <AddCircleIcon />
              </IconButton>
            )}
          </Box>
          {/*Абонементы*/}
          {props.invoices.length ? (
            <Box className="invoiceContainer">
              <Scrollbars>
                {props.invoices?.map((item, index) => (
                  <Box
                    className="invoice"
                    key={index}
                    onClick={() => setOpenInvoice({ id: item.id, open: true })}
                  >
                    <Box className="invoiceBlock">
                      <Box className="invoiceBlockLeftHeader">
                        <Box display="flex" flexDirection="column">
                          <h4 className="title-events-h">Занятия: {item.is_refundable ? <Tooltip title="Возвратный абонемент">
                              <LoopIcon className="invoicesHeaderLesson--loop-icon"/>
                          </Tooltip> : null}</h4>
                          <span>{moment(item.valid_to).format("MMMM")}</span>
                        </Box>
                        <label>{item.count}</label>
                      </Box>
                      <Box className="invoiceBlockRightHeader">
                        <label>{item.price} р.</label>
                        <span>{item.state.description}</span>
                      </Box>
                    </Box>
                    <Box className="invoiceBlock">
                      <Box className="invoiceBlockItems">
                        <Box display="flex" alignItems="center">
                          <Box sx={{ width: "35%" }}>Филиал:</Box>
                          <span>{item.group?.filial?.name}</span>
                        </Box>
                        <Box display="flex" alignItems="center">
                          <Box sx={{ width: "35%" }}>Группа:</Box>
                          <span>{item.group.name}</span>
                        </Box>
                      </Box>
                      <Box className="invoiceBlockDate">
                        <span>
                          <NewDate created_at={item.created_at} />
                        </span>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Scrollbars>
            </Box>
          ) : null}
        </Box>
        <CreateInvoice
          open={invoiceDialog}
          onClose={openCreateInvoiceDialog}
          groupsPlan={groupsPlan}
          children_id={children_id}
          createInvoice={createInvoice}
          invoiceDiscount={invoiceDiscount}
        />
        <Dialog
          open={openDialog}
          aria-labelledby="form-dialog"
          fullWidth
          maxWidth={"xs"}
        >
          <DialogTitle id="form-dialog-event-child">
            Добавить комментарий
          </DialogTitle>
          <DialogContent className="eventChildDialogContent">
            <TextField
              margin="dense"
              variant="outlined"
              placeholder="Добавить комментарий"
              multiline
              rows="3"
              fullWidth
              onChange={(e) =>
                handleChangedHistory({ content: e.target.value })
              }
            />
          </DialogContent>
          <DialogActions id="eventChildDialogAction">
            <Button variant="contained" onClick={onClose} id={"back-btn"}>
              Отмена
            </Button>
            <Button
              variant="contained"
              onClick={addEvent}
              disabled={historyChild.content === ""}
            >
              Добавить
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  } else
    return (
      <Redirect
        to={{
          pathname: `/admin/invoices/${openInvoice.id}`,
        }}
      />
    );
};

export default ChildEvents;
